let newsletterFormSuccess = new Event('growtypeFormNewsletterFormSuccess');

export function newsletterFormSuccessEvent() {
    return newsletterFormSuccess;
}
